import { render, staticRenderFns } from "./gameCard.vue?vue&type=template&id=47565ec8"
import script from "./gameCard.vue?vue&type=script&lang=js"
export * from "./gameCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports